import type { ResolvedConversationsSummaryTimeframe } from "./conversationsSummaryTypes"

export const TIMEFRAME_DAYS: Record<
  ResolvedConversationsSummaryTimeframe,
  number
> = {
  "24h": 1,
  "7d": 7,
  "30d": 30,
}
export const MIN_24H_CONVERSATIONS = 20
export const MIN_30D_CONVERSATIONS_FOR_DAILY_VIEW = 100
export const MIN_7D_CONVERSATIONS = 5
export const MIN_30D_CONVERSATIONS_FOR_WEEKLY_VIEW = 12
export const MIN_FINISHED_CONVERSATIONS_FOR_TREND = 2
export const MIN_COMPLETION_DELTA_POINTS = 5
export const MIN_METRIC_MOVEMENT_COUNT = 2
export const MIN_METRIC_RELATIVE_DELTA = 0.15
export const MIN_METRIC_ABSOLUTE_DELTA = 0.1
export const MIN_NEGATIVE_STRING_METRIC_COUNT = 2
export const MIN_NEGATIVE_STRING_METRIC_SHARE = 0.15
export const MIN_ISSUE_COUNT = 1
export const MAX_SECTION_ITEMS = 3
export const MAX_INLINE_LIST_ITEMS = 3
export const MAX_SIGNAL_ITEMS = 6
export const MAX_FOCUS_PREVIEW_LENGTH = 96
export const MS_PER_DAY = 24 * 60 * 60 * 1000
const PACIFIC_TIME_ZONE = "America/Los_Angeles"
export const FOCUS_SECTION_TITLE = "Focus"
export const WHAT_CHANGED_SECTION_TITLE = "What Changed"
export const WORTH_DIGGING_SECTION_TITLE = "Worth Digging Into"
export const FOCUS_STOP_WORDS = new Set([
  "about",
  "agent",
  "agents",
  "and",
  "are",
  "care",
  "for",
  "from",
  "has",
  "have",
  "health",
  "improve",
  "improving",
  "into",
  "metric",
  "metrics",
  "more",
  "since",
  "that",
  "the",
  "this",
  "trend",
  "trends",
  "what",
  "with",
  "working",
])

export const PACIFIC_DATE_FORMATTER = new Intl.DateTimeFormat("en-CA", {
  day: "2-digit",
  month: "2-digit",
  timeZone: PACIFIC_TIME_ZONE,
  year: "numeric",
})
